(function() {
  $(function() {
    return $('a.close-action').on('click', function(e) {
      e.preventDefault();
      return $(this).closest('.messages').slideUp(200);
    });
  });

}).call(this);
